import React, { useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Hero from "./Hero";
import Work from "./Work";
import ProjectsSection from "./ProjectsSection";
import Skills from "./Skills";
import Education from "./Education";
import { scrollToSection } from "./scrollToSection";

function HomePage() {
  const location = useLocation();
  const seen = useRef(false);
  const section = location.pathname.replace(/^\//, "");
  const target = section === "work" || section === "projects" ? section : "";

  useLayoutEffect(() => {
    if (!target) {
      seen.current = true;
      return;
    }
    const behavior = seen.current && location.state?.smooth ? "smooth" : "auto";
    seen.current = true;
    scrollToSection(target, behavior);
  }, [target, location.state]);

  return (
    <main id="content" tabIndex={-1}>
      <Hero />
      <Work />
      <ProjectsSection />
      <Skills />
      <Education />
    </main>
  );
}

export default HomePage;
